import { useQuery } from "@tanstack/react-query";
import { getMetaStatus } from "../../api/bMetaApi";

export const useGetMetaStatus = (organisationId, locationId=null, brandId=null, enabled = true) => {
  return useQuery({
    queryKey: ["meta-status", organisationId, locationId, brandId],
    queryFn: () => getMetaStatus(organisationId, locationId, brandId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};
